module.exports = __webpack_public_path__ + "img/A.6ff7f0d5.webp";